import { cn } from '@/lib/utils'

import { UNREAD_COUNT } from '@/constant/ui'
import { useForumUnread } from '@/contexts/forum-unread-context'

interface ForumNavUnreadIndicatorProps {
  className?: string
}

export function ForumNavUnreadIndicator({ className }: ForumNavUnreadIndicatorProps) {
  const { totalUnreadCount } = useForumUnread()

  if (totalUnreadCount <= 0) return null

  return (
    <span
      className={cn(
        'inline-flex h-5 min-w-[1.5rem] items-center justify-center rounded-full bg-destructive px-1.5 text-xs font-medium leading-none text-destructive-foreground',
        className
      )}
    >
      {totalUnreadCount > UNREAD_COUNT.MAX_DISPLAY ? UNREAD_COUNT.MAX_DISPLAY_TEXT : totalUnreadCount}
    </span>
  )
}
